// project-imports
import { deleteRequest, getRequest, postRequest } from 'utils/action-manager/actionManager';
import { APIAction } from '../apiManager';

// ==============================|| API MANAGER - DISCOVERY TRIP ||============================== //

export async function handleDiscoveryTrip(action: APIAction) {
  switch (action.method) {
    case 'list-admin':
      return getRequest('/discovery-trip/list-admin');
    case 'list':
      return getRequest(`/discovery-trip/list?agent-id=${action.data.agentId}`);
    case 'list-customer':
      return getRequest(`/discovery-trip/list?visitor-id=${action.data.visitorId}`);
    case 'create-update':
      return postRequest(`/discovery-trip`, action.data);
    case 'read-admin':
      return getRequest(`/discovery-trip/${action.id}`);
    case 'read-by-agent-id':
      return getRequest(`/discovery-trip/${action.id}?agent-id=${action.data.agentId}`);
    case 'delete':
      return deleteRequest(`/discovery-trip/${action.id}`);
    default:
      console.info('[ApiManager > handleApiAction > handleDiscoveryTrip] - Unknown method');
      break;
  }
}
